import './openlayers.js';
import './chartingInterop.js';
import './tooltip.js';
import './ClickOutside.js';

import { kinks } from "@turf/kinks";
window.turf = {kinks: kinks};

// Re-export the global for modules that import this file.
export default window.ol
